import styled from 'styled-components';
import { Media } from 'enums';

export const Ellipsis = styled.div`
  width: 35px; // FIXME: need take it sizes from common constants for item pagination
  height: 35px;
  display: flex;
  justify-content: center;
  align-items: center;

  @media ${Media.notebook} {
    width: 40px;
    height: 40px;
  }
`;
